import { usePath } from "../libs/path/PathProvider";
import AccountSelect from "./AccountSelect";
import usePortfolio from "../hooks/PortfolioProvider";
import _ from "lodash";

export default function AccountFilter(){
    const {setQuery, query} = usePath()
    const {portfolio} = usePortfolio()
    const onSelect = (account:number|null) => setQuery({account:account!})
    let current = query.account ? parseInt(query.account as string) : -1
    if (_.findIndex(portfolio.accounts, a => a.id==current)<0) current = -1
    return <AccountSelect showAll={true} onSelect={onSelect} current={current}/>
}